import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { IoMenuSharp, IoClose } from 'react-icons/io5';
import { BiChevronRight } from 'react-icons/bi';
import { Link, useLocation } from 'react-router-dom';

export default function NavDrawer() {
    const [state, setState] = useState({ right: false });
    const location = useLocation();
    const isHome = location.pathname == '/';
    const isSolution = location.pathname == '/Solution';
    const isService = location.pathname == '/Service';
    const isAbout = location.pathname == '/About';
    const isContact = location.pathname == '/Contact';

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : '315px' }}
            className='drawer_div'
            role="presentation"
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <div>
                    <div className='close_icon_div'>
                        <IoClose className='close_icon' onClick={toggleDrawer('right', false)} />
                    </div>
                    <ul className='mobile_nav_ul'>
                        <li className={isHome ? 'li' : null}>
                            <Link onClick={toggleDrawer(anchor, false)}
                                className={isHome ? 'mobile_active_link' : 'mobile_link'} to='/'>
                                Home
                            </Link>
                        </li>
                        <li className={isSolution ? 'li' : null}>
                            <Link onClick={toggleDrawer(anchor, false)}
                                className={isSolution ? 'mobile_active_link' : 'mobile_link'} to='/Solution'>
                                Solutions
                            </Link>
                            <button><BiChevronRight className={isSolution ? 'active_right_arror_icon' : 'right_arror_icon'} /></button>
                        </li>
                        <li className={isService ? 'li' : null}>
                            <Link onClick={toggleDrawer(anchor, false)}
                                className={isService ? 'mobile_active_link' : 'mobile_link'} to='/Service'>
                                Services
                            </Link>
                            <button><BiChevronRight className={isService ? 'active_right_arror_icon' : 'right_arror_icon'} /></button>
                        </li>
                        <li className={isAbout ? 'li' : null}>
                            <Link onClick={toggleDrawer(anchor, false)}
                                className={isAbout ? 'mobile_active_link' : 'mobile_link'} to='/About'>
                                About
                            </Link>
                            <button><BiChevronRight className={isAbout ? 'active_right_arror_icon' : 'right_arror_icon'} /></button>
                        </li>
                        <li className={isContact ? 'li' : null}>
                            <Link onClick={toggleDrawer(anchor, false)}
                                className={isContact ? 'mobile_active_link' : 'mobile_link'} to='/Contact'>
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>
            </List>
        </Box>
    );

    return (
        <div>
            <button className='menu_btn' onClick={toggleDrawer('right', true)}>
                <IoMenuSharp className='menu_icon' />
            </button>
            <Drawer
                anchor={'right'}
                open={state['right']}
                onClose={toggleDrawer('right', false)}
            >
                {list('right')}
            </Drawer>
        </div>
    );
}
